'use client'

import { useState, useEffect } from 'react'
import ThemeClient from '@/app/v1/ThemeClient'
import styles from './slug.module.scss'
import NextLink from 'next/link'
import {
  Stack,
  Chip
} from '@mui/material'
import { ITag } from '@/interfaces/ITag'
import cookieService from '@/modules/cookieService'

function FooterTags ({ tags }: { tags: ITag[] }) {
  const [selectedTheme, setSelectedTheme] = useState('')

  useEffect(() => {
    const storedTheme = cookieService.getCookie('theme')
    setSelectedTheme(storedTheme || 'dark')
  }, [])

  return (
    <ThemeClient theme={selectedTheme}>
      <div style={{ marginTop: '4rem' }}>
        <Stack direction="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
          {tags.map((tag, i) => {
            return (
              <NextLink
                key={i}
                style={{ marginBottom: '1rem', marginRight: '0.5rem' }}
                href={`/feed?topic=${tag.id}`}
              >
                <Chip
                  label={tag.name}
                  size="small"
                  className={styles.tagChip}
                />
              </NextLink>
            )
          })}
        </Stack>
      </div>
    </ThemeClient>
  )
}

export default FooterTags
